<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Contacts</translate></template>
            <template v-slot:buttons>
                <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_contacts'" /> -->
                <GekkoButton 
                    :text="$gettext('New contact')" 
                    :to="{name: 'AddContact'}"
                    icon="fa-solid fa-plus"
                    class="mr-2"
                />
                <GekkoButton 
                    @click="download"
                    :text="$gettext('Download')" 
                    icon="fa-solid fa-download"
                    class="mr-2"
                    variant="outline-primary"
                />
                <GekkoButton 
                    @click="importContacts"
                    :text="$gettext('Import')" 
                    icon="fa-solid fa-upload"
                    variant="outline-primary"
                />
            </template>
        </TitleBar>
        <div class="content">
            <ContactTable></ContactTable>
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import ContactTable from "@/components/contacts/ContactTable";
import GekkoButton from "@/components/GekkoButton";
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
    name: "Contacts",
    components: { 
        TitleBar, 
        ContactTable, 
        GekkoButton,
        // OnboardingIntroLink 
    },
    data() {
        return {
        }
    },
    methods: {
        goToAddContact() {
            this.$router.push({name: 'AddContact'});
        },
        download() {
            let filters = this.$store.getters['filterStore/getFilter'];
            let queryString = this.encodeQueryData(filters);
            let url = window.Urls['company_profile_export_customers'](window.company_id);
            if (queryString)
                url += "?" + queryString;
            window.location.href = url;
        },
        importContacts() {
            window.location.href = window.Urls['accounts_import_data_settings']();
        },
        encodeQueryData(data) {
            var ret = [];
            for (var d in data)
                if (data[d]) {
                    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                }
            return ret.join("&");
        }
    }
}
</script>

<style scoped>

</style>
